import "./allWorkListTable.css";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import Table from "react-bootstrap/Table";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  GET_WORKFLOW_REQUEST,
  GET_SUBMITTED_REQUEST_LIST,
  WORKFLOW_ACTION_TAKEN,
} from "../../../common/URLs";

import { loaderService } from "../../../common/custom-loader/loader-service";
import { useLocation } from "react-router-dom";
import { getWorkflowActionTknRqDetails, getWorkflowRequestDetails } from "./workListAPIs";
import jwt from "jwt-decode";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import {
  Container,
  Stack,
  Box,
  Typography,
  Grid,
  Button,
  Tooltip,
  IconButton,
} from "@mui/material";
import BackButton from "../../../common/backButton";
import { DataGrid } from "@mui/x-data-grid";
import CustomDataGridToolbar from "../../../common/customDataGridToolbar";
import { NO_DATA_AVAILABLE } from "../../../common/constants";
import { DeleteIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";
import { deleteDraftRateByReqNo, fetchDraftedRateCard } from "../rateCard/rateCardAPIs";
import { toast } from "react-toastify";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";

function AllWorkListTable({ type }) {
  const decoded = jwt(getLocalStorageItem("id_token"));
  const shoullog = useRef(true);
  const { state } = useLocation();
  const navigate = useNavigate();
  const location = useLocation();
  let userRoleDetails = localStorage.getItem("role");
  const [getallworkflowdata, setgetallworkflowdata] = useState();
  const [selectedType, setSelectedType] = useState("");
  const [selectedRequestNumber, setSelectedRequestNumber] = useState("");
  const [workFlowRequestDetails, setWorkFlowRequestDetails] = useState();
  const [filterTable, setFilterTable] = useState({
    workflowType: "",
    stakeholderType: "",
  });
  const [filteredArr, setFilteredArr] = useState();
  const [currentStatus, setCurrentStatus] = useState();
  const [deleteDraftItem, setDeleteDraftItem] = useState();
  const [deleteDraftReqResponse, setDeleteDraftReqResponse] = useState();

  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);

  useEffect(() => {
    if (filterTable.workflowType || filterTable.stakeholderType) {
      const tempArr =
        getallworkflowdata &&
        getallworkflowdata?.filter((item) => {
          let keep = true;
          if (filterTable.workflowType) {
            keep =
              keep &&
              item.workflowType
                ?.toLowerCase()
                ?.includes(filterTable?.workflowType.toLowerCase().trim());
          }
          if (filterTable.stakeholderType) {
            keep =
              keep &&
              item.stakeholderType
                ?.toLowerCase()
                ?.includes(filterTable?.stakeholderType.toLowerCase().trim());
          }
          return keep;
        });
      setFilteredArr(tempArr);
    } else {
      setFilteredArr();
    }
  }, [filterTable.workflowType, filterTable.stakeholderType]);

  useEffect(() => {
    if (type === "sent" || state?.type === "sent") {
      sentWorkFlow();
    } else if (type === "actionTaken" || state?.type === "actionTaken") {
      actionTakenWorkFlow();
    } else {
      getAllWorkFlow();
    }
    // }
  }, [localStorage.getItem("role")]);

  useEffect(() => {
    if (workFlowRequestDetails) {
      if (
        selectedType === "PLANTATION_BATCH" ||
        selectedType === "SCRUTI_PLANTATION"
      ) {
        navigate("plantViewDetails", {
          state: {
            workFlowRequestDetails: workFlowRequestDetails,
            selectedRequestNumber: selectedRequestNumber,
            type: type,
          },
        });
      }
      if (
        selectedType === "RATE_CARD" ||
        selectedType === "RATE_GROWER" ||
        selectedType === "RATE_LLE" ||
        selectedType === "RATE_ISO"
      ) {
        navigate("previewRateCard", {
          state: {
            addedRateCardDetailsArr: currentStatus === "Draft" ? workFlowRequestDetails : workFlowRequestDetails?.rateCardDtlsLst,
            selectedRequestNumber: selectedRequestNumber,
            type: type,
            category: currentStatus === "Draft" ? workFlowRequestDetails?.[0]?.category : workFlowRequestDetails?.rateCardDtlsLst?.[0]?.category,
            itemType: currentStatus === "Draft" ? workFlowRequestDetails?.[0]?.itemType : workFlowRequestDetails?.rateCardDtlsLst?.[0]?.itemType,
            currentStatus: currentStatus === "Draft" ? "Draft" : ''
          },
        });
      }
      if (selectedType === "STAKEHOLDER_MAPPING") {
        navigate("verifyStakeHolderMapping", {
          state: {
            workFlowRequestDetails: workFlowRequestDetails,
            selectedRequestNumber: selectedRequestNumber,
            type: type,
          },
        });
      }
      if (selectedType === "KNOWLEDGE_MANAGEMENT") {
        navigate("verifyKnowledgeManagement", {
          state: {
            workFlowRequestDetails: workFlowRequestDetails,
            selectedRequestNumber: selectedRequestNumber,
            type: type,
          },
        });
      }
    }
  }, [workFlowRequestDetails]);

  function getAllWorkFlow() {
    loaderService.showLoader();
    apiClient
      .post(
        GET_WORKFLOW_REQUEST,
        {
          userRole: localStorage.getItem("role"),
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setgetallworkflowdata(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function sentWorkFlow() {
    loaderService.showLoader();
    apiClient
      .post(
        GET_SUBMITTED_REQUEST_LIST,
        {},
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setgetallworkflowdata(response.data.workflowRequestListPojo);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  function actionTakenWorkFlow() {
    loaderService.showLoader();
    apiClient
      .post(
        WORKFLOW_ACTION_TAKEN,
        {
          userRole: localStorage.getItem("role"),
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setgetallworkflowdata(response.data);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }

  const onRequestType = (e, selectedItem) => {
    setCurrentStatus(selectedItem?.currentStatus)
    if (selectedItem?.currentStatus === "Draft") {
      fetchDraftedRateCard(selectedItem?.requestNumber, setWorkFlowRequestDetails)
      setSelectedType(selectedItem?.workflowType);
      setSelectedRequestNumber(selectedItem?.requestNumber);
    }
    else if (type === "actionTaken") {
      getWorkflowActionTknRqDetails(
        selectedItem?.requestNumber,
        setWorkFlowRequestDetails,
        type === "sent" ? "Y" : "N"
      );
      setSelectedType(selectedItem?.workflowType);
      setSelectedRequestNumber(selectedItem?.requestNumber);
    }
    else {
      getWorkflowRequestDetails(
        selectedItem?.requestNumber,
        setWorkFlowRequestDetails,
        type === "sent" ? "Y" : "N"
      );
      setSelectedType(selectedItem?.workflowType);
      setSelectedRequestNumber(selectedItem?.requestNumber);
    }

  };

  const viewworklist = [
    {
      field: "requestNumber",
      headerName: "Request No/Approval Note No",
      width: 250,
    },
    { field: "workflowType", headerName: "Request Type", width: 220 },
    { field: "stakeholderType", headerName: "StakeHolder Type", width: 240 },
    {
      field: "currentStatus",
      headerName: type == "actionTaken" ? "Action Taken" : "Status",
      width: 180,
    },
    {
      field: "currentOwner",
      headerName: "Current Owner",
      width: 200,
      hide: type == "actionTaken",
    },
    { field: "createdBy", headerName: "Created By", width: 220 },
    { field: "updatedBy", headerName: "Action Taken By", width: 220 },
    {
      field: "approvedBy",
      headerName: "Approved By",
      width: 220,
      hide: type == "actionTaken" || type == "all",
    },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => (
        <>
          <Tooltip title="View">
            <IconButton
              style={{
                border: "none",
                color: "#1976D2",
                background: "none",
              }}
              color="primary"
              onClick={(e) => onRequestType(e, params?.row)}
            >
              <ViewIcon />
            </IconButton>
          </Tooltip>
          {
            params?.row?.currentStatus === "Draft" &&
            <Tooltip title="Delete">
              <IconButton
                color="error"
                onClick={(e) => onDeleteDrafReq(params?.row, setDeleteDraftReqResponse)}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          }

        </>
      ),
    },
  ];

  const onDeleteDrafReq = (selectedItem) => {
      setDeleteDraftItem(selectedItem)
      handleConfirmLogModalOpen();
  };

  function onConfirmDrafDelete() {
    handleConfirmLogModalClose();
    deleteDraftRateByReqNo(deleteDraftItem?.requestNumber, setDeleteDraftReqResponse)
  }

  function onCancelDraftDelete() {
    handleConfirmLogModalClose();
  }

  useEffect(() => {
    if (deleteDraftReqResponse) {
      if (deleteDraftReqResponse.status === "SUCCESS") {
        toast.success("Draft deleted successfully")
        sentWorkFlow();
      }
      else {
        toast.error(deleteDraftReqResponse?.description)
      }
    }
  }, [deleteDraftReqResponse])

  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p className="pageNumberingResc">RES11</p>}
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <BackButton navigate={navigate} />
          <Typography variant="h5" gutterBottom>
            {type === "sent" || state?.type === "sent"
              ? "View Sent For Approval"
              : "View All WorkList"}
          </Typography>
        </Stack>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={12}>
            <Box sx={{ height: 450, width: "100%", mt: 2 }}>
              <DataGrid
                rows={getallworkflowdata ? getallworkflowdata : []}
                columns={viewworklist}
                pageSize={10}
                rowsPerPageOptions={[5]}
                getRowId={(row) => row?.requestNumber}
                initialState={{
                  sorting: {
                    sortModel: [{ field: "requestNumber", sort: "desc" }],
                  },
                }}
                components={{
                  Toolbar: CustomDataGridToolbar,
                }}
                componentsProps={{
                  toolbar: {
                    rows: getallworkflowdata,
                    columns: viewworklist,
                    fileName: "WorkLogList.xlsx",
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
      <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmDrafDelete} onClose={onCancelDraftDelete} action="Delete" />
    </>
  );
}
export default AllWorkListTable;
